import * as React from 'react';
import { Button } from '@cian/ui-kit/button';

import { SavePopupContainer } from '../../../filters/components/save/popup/container';
import { trackShowSaveSearchClick } from '../tracking';
import { HeartStroke16 } from '@cian/ui-kit';

export function SaveSearchButton() {
  const [opened, setOpened] = React.useState(false);

  const handleClick = React.useCallback(() => {
    trackShowSaveSearchClick();
    setOpened(opened => !opened);
  }, []);

  return (
    <>
      <Button
        theme="fill_white_primary"
        size="XS"
        beforeIcon={<HeartStroke16 color="primary_100" />}
        onClick={handleClick}
      >
        Сохранить поиск
      </Button>

      {opened && <SavePopupContainer onClose={() => setOpened(false)} />}
    </>
  );
}
